import { render, staticRenderFns } from "./AttachPostMedia.vue?vue&type=template&id=a0c6fc28"
import script from "./AttachPostMedia.vue?vue&type=script&lang=js"
export * from "./AttachPostMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports